import { HTTPError } from 'ky';

/**
 * Utility function to determine if an error is a client-side error (4xx).
 * @param error - The error object to check.
 * @returns `true` if the status code is a client error (4xx), otherwise `false`.
 */
export const isClientError = (error: Error | null): boolean => {
  let has4xxError = false;
  if (error instanceof HTTPError) {
    has4xxError = error.response.status >= 400 && error.response.status < 500;
  } else if (error?.message) {
    const match = error.message.match(/status code (\d{3})/);
    if (match) {
      const statusCode = parseInt(match[1], 10);
      has4xxError = statusCode >= 400 && statusCode < 500;
    }
  }

  return has4xxError;
};
